import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { User } from '@triare/auth-redux/dist/saga/auth/useMe';
import { actions } from './index';

export interface UserResendLinkParams {
  id: string;
}

export const userResendLink = (payload: UserResendLinkParams): Action<UserResendLinkParams> => ({
  type: actions.userResendLinkTrigger.toString(),
  payload,
});

export const userResendLinkClear = (): Action => ({
  type: actions.userResendLinkClear.toString(),
});

export const userResendLinkErrorClear = (): Action => ({
  type: actions.userResendLinkErrorReset.toString(),
});

export function* userResendLinkRequestSaga({ payload }: Action<UserResendLinkParams>) {
  yield put({
    type: actions.userResendLinkStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.userResendLinkError.toString(),
      payload: {
        message: 'UserResendLink: Parameters not passed.',
      },
    });

    return;
  }

  const { id } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/users/${id}/resend-link`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<User, User>(
    response,
    actions.userResendLinkSuccess.toString(),
    actions.userResendLinkError.toString(),
    false,
    (userResendLinkData) => userResendLinkData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.userResendLinkTrigger.toString(),
    defaultProcessingSaga(userResendLinkRequestSaga, {
      error: actions.userResendLinkError.toString(),
      locationCancel: actions.userResendLinkClear.toString(),
    }),
  );

  yield takeLatest(actions.userResendLinkSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.userResendLinkError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.userResendLinkErrorReset.toString(),
    });
  });
}
